import React from "react";
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import HomeIcon from '@mui/icons-material/Home';
import PeopleIcon from '@mui/icons-material/People';
import ShoppingCartCheckoutSharpIcon from '@mui/icons-material/ShoppingCartCheckoutSharp';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import WindowIcon from '@mui/icons-material/Window';
import AssessmentIcon from '@mui/icons-material/Assessment';
import HandymanIcon from '@mui/icons-material/Handyman';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import BuildIcon from '@mui/icons-material/Build';
import SmsIcon from '@mui/icons-material/Sms';
import HistoryIcon from '@mui/icons-material/History';

import {
  Link as RouterLink,
} from 'react-router-dom';
import { Typography, Link as OGLink, Badge } from "@mui/material";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

import ListItemButton from "@mui/material/ListItemButton";
import { useSmsUnread } from "./ReactQuery/QuerySmsUnread";

const item = {
  py: '2px',
  px: 3,
  color: 'rgba(255, 255, 255, 0.7)',
  '&:hover, &:focus': {
    bgcolor: 'rgba(255, 255, 255, 0.08)',
  },
};

const itemCategory = {
  boxShadow: '0 -1px 0 rgb(255,255,255,0.1) inset',
  py: 1.5,
  px: 3,
};

function Copyright() {
  return (
    <Typography variant="body2" color={item.color} align="center">
      {'Copyright © '}
      <OGLink color="inherit" href="https://cedartitans.com/">
        Cedar Titans LLC
      </OGLink>{' '}
      {new Date().getFullYear()}.
    </Typography>
  );
}

const Link = React.forwardRef(function Link(itemProps, ref) {
  return <RouterLink to="#" ref={ref} {...itemProps} role={undefined} />;
});


export default function Navigator({ PaperProps, sx, currenttab, my_user, selectedLocation, setOpenChat, variant = "permanent", open, onClose }) {
  const { data: unreadSmsMessages } = useSmsUnread();
  // const [drawer_open, setDrawer_open] = React.useState(true)
  const categories = [
    {
      id: 'Rental',
      client_attribute: 'has_rental',
      children: [
        { id: 'Reserve', displayName: 'Reserve', icon: <AccessTimeFilledIcon /> },
        { id: 'Contracts', displayName: 'Contracts', icon: <ShoppingCartCheckoutSharpIcon /> },
        { id: 'RentalConfigs', displayName: 'Configurations', icon: <SettingsIcon /> },
        { id: 'RentalItems', displayName: 'Rental Items', icon: <WindowIcon /> },
      ],
    },
    {
      id: 'Service',
      client_attribute: 'has_service',
      children: [
        { id: 'NewServiceOrder', displayName: 'New Service Order', icon: <AddCircleIcon />, },
        { id: 'ServiceOrders', displayName: 'Service Orders', icon: <HandymanIcon />, },
        { id: 'ServiceOrderParts', displayName: 'Service Order Parts', icon: <BuildIcon /> },
        { id: 'ServiceKits', displayName: 'Service Kits', icon: <LibraryBooksIcon /> },
        { id: 'ServiceOrderItemTypes', displayName: 'Service Item Types', icon: <AgricultureIcon /> },
        { id: 'ServiceOrderFees', displayName: 'Service Order Fees', icon: <SettingsIcon /> },
        { id: 'ServiceOrderWarrantyClaims', displayName: 'Warranty Claims', icon: <FolderSpecialIcon /> },
      ],
    },
    {
      id: 'Inventory',
      client_attribute: 'has_inventory',
      children: [
        { id: 'InventoryItems', displayName: 'Inventory Items', icon: <WindowIcon />, },
      ],
    },
    {
      // id: 'Config',
      children: [
        {
          id: 'Chat', icon: <Badge badgeContent={selectedLocation.id === 'all' ? Object.keys(unreadSmsMessages).reduce((a, x) => a + unreadSmsMessages[x], 0) : unreadSmsMessages[selectedLocation.id] ?? 0} color="primary"><SmsIcon /></Badge>, onClick: (e) => {
            e.preventDefault();
            setOpenChat(true);
          }
        },
        { id: 'Users', icon: <AccountCircleIcon />, user_permissions_attribute: ['permissions_user_admin'] },
        { id: 'ServiceTechnicianHistory', displayName: 'Technician Work History', icon: <HistoryIcon />, user_permissions_attribute: ['permissions_service_manager'], client_attribute: 'has_service' },
        { id: 'Customers', icon: <PeopleIcon /> },
        { id: 'Locations', icon: <LocationOnIcon />, user_permissions_attribute: ['permissions_config_admin'] },
        { id: 'Reports', displayName: 'Reports', icon: <AssessmentIcon />, user_permissions_attribute: ['permissions_reports_user'] },
      ],
    },
    {
      // id: 'Config',
      user_permissions_attribute: ['permissions_config_admin'],
      children: [
        { id: 'Client', displayName: 'Client Configurations', icon: <AdminPanelSettingsIcon />, user_permissions_attribute: ['permissions_config_admin'] },
      ],
    },
  ]

  // toggleDrawer = (e, open) => {
  //   this.setState({ drawer_open: !this.state.drawer_open });
  // };

  const filtered_categories = categories.filter((category) =>
  (
    (category.client_attribute === undefined || my_user.client[category.client_attribute]) &&
    (my_user.root_admin || category.user_permissions_attribute === undefined || category.user_permissions_attribute.some((x) => my_user[x]))
  )
  )

  return (
    (<Drawer sx={sx} PaperProps={PaperProps} onClose={onClose} open={open} variant={variant}>
      <OverlayScrollbarsComponent>
        <Box>
          <List disablePadding>
            <ListItem key="reaper" sx={{ ...item, ...itemCategory, fontSize: 21, color: '#fff' }} component={Link} to={"/Home"} onClick={onClose}>
              <Box>
                <span>ProfitMax Pro Suite</span><br />
                {/* <Box
                    component="span"
                    sx={{ float: 'right', fontSize: 16 }}
                  >
                    -Rental
                  </Box> */}
              </Box>
            </ListItem>
            <ListItem key="home" sx={{ ...item, ...itemCategory }} component={Link} to={"/Dashboard"} onClick={onClose}>
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText>Dashboard</ListItemText>
            </ListItem>
            {filtered_categories.map(({ id, children }, index) => (
              <Box key={id || index} sx={{ bgcolor: '#101F33' }}>
                {id &&
                  <ListItem key={id} sx={{ py: 1, px: 3 }}>
                    <ListItemText sx={{ color: '#fff' }}>{id}</ListItemText>
                  </ListItem>
                }
                {id === undefined &&
                  <Box sx={{ height: '10px' }} />
                }
                {children.map(({ id: childId, icon, displayName, user_permissions_attribute, client_attribute, onClick }) => {
                  if ((client_attribute === undefined || my_user.client[client_attribute]) && (
                    my_user.root_admin ||
                    (
                      (user_permissions_attribute === undefined || user_permissions_attribute.some((x) => my_user[x]))
                    ))) {
                    return (
                      (<ListItemButton
                        key={childId}
                        selected={currenttab.includes(childId.toLowerCase())}
                        sx={item}
                        component={Link}
                        to={"/" + childId}
                        onClick={(e) => {
                          onClose && onClose(e);
                          onClick && onClick(e);
                        }}>
                        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
                        <ListItemText primary={displayName || childId} />
                      </ListItemButton>)
                    );
                  } else {
                    return undefined
                  }
                })}
                <Divider sx={{ mt: 2 }} />
              </Box>
            ))}
          </List>
          <Box component="footer" sx={{ pb: 2, mt: "auto" }}>
            <Copyright />
          </Box>
        </Box>
      </OverlayScrollbarsComponent>
    </Drawer>)
  );
}